module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tsv-words"
  }, [_c('header', {
    staticClass: "mdl-layout__header mdl-color--grey-100 mdl-color-text--grey-600"
  }, [_c('div', {
    staticClass: "mdl-layout__header-row"
  }, [(_vm.analyzer.type == 'words') ? _c('span', {
    staticClass: "mdl-layout-title"
  }, [_vm._v(_vm._s(_vm.global_i18n().words.title))]) : _vm._e(), _vm._v(" "), (_vm.analyzer.type == 'ads') ? _c('span', {
    staticClass: "mdl-layout-title"
  }, [_vm._v(_vm._s(_vm.global_i18n().ads.title))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "mdl-layout-spacer"
  }), _vm._v(" "), (_vm.inputTable) ? _c('div', {
    staticClass: "search"
  }, [_c('div', {
    staticClass: "mdl-textfield mdl-js-textfield mdl-textfield--expandable"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "mdl-textfield__expandable-holder"
  }, [_c('input', {
    staticClass: "mdl-textfield__input",
    attrs: {
      "type": "text",
      "id": "search"
    },
    domProps: {
      "value": _vm.searchText
    },
    on: {
      "change": function($event) {
        _vm.handleSearchChange($event, true)
      },
      "input": function($event) {
        _vm.handleSearchChange($event, false)
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "mdl-textfield__label",
    attrs: {
      "for": "search"
    }
  }, [_vm._v(_vm._s(_vm.i18n().searchBox))])])])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "mdl-grid"
  }, [(_vm.inputTable == null && _vm.state == 'ready') ? _c('div', {
    staticClass: "load-tsv mdl-card mdl-shadow--2dp"
  }, [_c('div', {
    staticClass: "mdl-card__title mdl-card--expand"
  }, [_c('h2', {
    staticClass: "mdl-card__title-text"
  }, [_vm._v(_vm._s(_vm.i18n().csvOrTsv))])]), _vm._v(" "), _c('div', {
    staticClass: "mdl-card__supporting-text"
  }, [_c('LoadFile', {
    on: {
      "file": function (file) { return _vm.handleFileLoaded(file); }
    }
  }, [_vm._v(">")])], 1)]) : _vm._e(), _vm._v(" "), (_vm.inputFileError) ? _c('div', {
    staticClass: "file-error-holder"
  }, [_c('div', {
    staticClass: "file-error mdl-card mdl-shadow--4dp"
  }, [_c('div', {
    staticClass: "mdl-card__title"
  }, [_c('h2', {
    staticClass: "mdl-card__title-text"
  }, [_vm._v(_vm._s(_vm.i18n().inputError.title))])]), _vm._v(" "), _c('div', {
    staticClass: "mdl-card__supporting-text mdl-card--expand"
  }, [_vm._v("\n          " + _vm._s(_vm.i18n().inputError[_vm.inputFileError.type] ? _vm.i18n().inputError[_vm.inputFileError.type](_vm.inputFileError) :
    _vm.inputFileError.type) + "\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "mdl-card__actions mdl-card--border"
  }, [_c('a', {
    staticClass: "mdl-button mdl-button--colored mdl-js-button mdl-js-ripple-effect",
    on: {
      "click": _vm.retry
    }
  }, [_vm._v("\n            OK\n          ")])])])]) : _vm._e(), _vm._v(" "), (_vm.state == 'parsing' && !_vm.inputFileError) ? _c('div', {
    staticClass: "parsing-holder"
  }, [_c('h3', [_vm._v("Reading Data...")]), _vm._v(" "), _c('div', {
    staticClass: "mdl-progress mdl-js-progress mdl-progress__indeterminate",
    attrs: {
      "id": "p2"
    }
  }), _vm._v(" "), _c('h4', [_vm._v("Please wait!")])]) : _vm._e(), _vm._v(" "), (_vm.state == 'parsed') ? _c('div', [(_vm.analyzer.type == 'words') ? _c('div', [_c('WordsAnalyzer', {
    attrs: {
      "inputTable": _vm.inputTable,
      "searchText": _vm.searchText
    },
    on: {
      "file": function (file) { return _vm.handleFileLoaded(file); }
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.analyzer.type == 'ads') ? _c('div', [_c('AdsAnalyzer', {
    attrs: {
      "inputTable": _vm.inputTable,
      "searchText": _vm.searchText
    },
    on: {
      "file": function (file) { return _vm.handleFileLoaded(file); }
    }
  })], 1) : _vm._e()]) : _vm._e()])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "mdl-button mdl-js-button mdl-button--icon",
    attrs: {
      "for": "search"
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("search")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0d381038"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/CsvAnalyzer.vue
// module id = 432
// module chunks = 0